// JavaScript to find and hide add to cart buttons on PRODUCT CARDS ONLY on mobile

// Function to check if an element is part of Recharge functionality
function isRechargeElement(element) {
  if (!element) return false;
  
  // Check for Recharge-specific attributes and classes
  const rechargeSelectors = [
    '[data-recharge]', '[data-rc]', '.recharge', '.rc-',
    '[data-recharge-upsell]', '[data-rc-upsell]',
    '[data-recharge-cart]', '[data-rc-cart]',
    '[data-recharge-subscription]', '[data-rc-subscription]'
  ];
  
  // Check if element matches any Recharge selector
  for (const selector of rechargeSelectors) {
    if (element.matches && element.matches(selector)) return true;
    if (element.closest && element.closest(selector)) return true;
  }
  
  // Check for Recharge attributes
  const rechargeAttrs = ['data-recharge', 'data-rc', 'data-recharge-upsell', 'data-rc-upsell'];
  for (const attr of rechargeAttrs) {
    if (element.hasAttribute && element.hasAttribute(attr)) return true;
  }
  
  // Check for Recharge classes
  const rechargeClasses = ['recharge', 'rc-', 'recharge-upsell', 'rc-upsell'];
  for (const className of rechargeClasses) {
    if (element.classList && element.classList.contains(className)) return true;
  }
  
  return false;
}

function hideAddToCartButtonsMobile() {
  // Only run on mobile devices
  if (window.innerWidth >= 750) {
    return; // Don't hide buttons on desktop
  }
  
  // Find all buttons with add to cart text WITHIN product cards only
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    const buttons = card.querySelectorAll('button');
    buttons.forEach(button => {
      // Skip buttons that are part of Recharge or other essential functionality
      if (isRechargeElement(button)) {
        return; // Don't hide Recharge buttons
      }
      
      const text = button.textContent ? button.textContent.toLowerCase() : '';
      if (text.includes('add to cart') || text.includes('quick add') || text.includes('add to bag')) {
        button.style.display = 'none';
        button.style.visibility = 'hidden';
        button.style.opacity = '0';
        button.style.pointerEvents = 'none';
        button.style.position = 'absolute';
        button.style.left = '-9999px';
        button.style.top = '-9999px';
        button.style.width = '0';
        button.style.height = '0';
        button.style.overflow = 'hidden';
        button.style.zIndex = '-1';
      }
    });
  });
  
  // Hide common add to cart selectors WITHIN product cards only
  // Note: We exclude forms that might be needed for Recharge upsell detection
  const selectors = [
    '.quick-add__wrapper',
    '.quick-add',
    'quick-add',
    'quick-add-component',
    '.add-to-cart-component',
    'add-to-cart-component',
    '.quick-add__button',
    '.quick-add__button--add',
    '.quick-add__button--choose',
    '.button.quick-add__button',
    'button[name="add"]',
    // Exclude forms from hiding as they might be needed for Recharge
    // 'form[action="/cart/add"]',
    // 'form[data-type="add-to-cart-form"]',
    // 'product-form-component',
    // 'product-form',
    '.add-to-cart-text',
    '.add-to-cart-text__content'
  ];
  
  productCards.forEach(card => {
    selectors.forEach(selector => {
      const elements = card.querySelectorAll(selector);
      elements.forEach(element => {
        // Skip elements that are part of Recharge or other essential functionality
        if (isRechargeElement(element)) {
          return; // Don't hide Recharge elements
        }
        
        if (element instanceof HTMLElement) {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.style.opacity = '0';
          element.style.pointerEvents = 'none';
          element.style.position = 'absolute';
          element.style.left = '-9999px';
          element.style.top = '-9999px';
          element.style.width = '0';
          element.style.height = '0';
          element.style.overflow = 'hidden';
          element.style.zIndex = '-1';
        }
      });
    });
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', hideAddToCartButtonsMobile);

// Run immediately
hideAddToCartButtonsMobile();

// Run periodically to catch dynamically added buttons (mobile only)
setInterval(hideAddToCartButtonsMobile, 500);

// Run on any mutations to the DOM (mobile only)
if (window.MutationObserver) {
  const observer = new MutationObserver(() => {
    hideAddToCartButtonsMobile();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Also run on window load and resize
window.addEventListener('load', hideAddToCartButtonsMobile);
window.addEventListener('resize', hideAddToCartButtonsMobile); 